import { useActivationStore } from '@/stores/ActivationStore/ActivationStore';
import { useAuthenticationStore } from '@/stores/AuthenticationStore/AuthenticationStore';
import { useAuthorizationStore } from '@/stores/AuthorizationStore/AuthorizationStore';
import { useBulkUploadStore } from '@/stores/BulkUploadStore/BulkUploadStore';
import { useInventoryStore } from '@/stores/InventoryStore/InventoryStore';
import { useInvitationStore } from '@/stores/InvitationStore/InvitationStore';
import { useModeStore } from '@/stores/ModeStore/ModeStore';
import { useNotificationStore } from '@/stores/NotificationStore/NotificationStore';
import { usePaymentProfileStore } from '@/stores/Profile/PaymentProfileStore';
import { useUserStore } from '@/stores/User/UserStore';
import { usePurchaseRequestsStore } from '@/stores/PurchaseRequestsStore/PurchaseRequestsStore';
import { useQRLabelsStore } from '@/stores/QRLabelsStore/QRLabelsStore';
import { useSalesAgreementStore } from '@/stores/SalesAgreementStore/SalesAgreementStore';
import { useTeamStore } from '@/stores/TeamStore/TeamStore';
import { useArtistStore } from '@/stores/ArtistStore/ArtistStore';
/**
 * StoreManager provides centralized management of store operations
 * that affect multiple stores or require coordination between stores.
 */

export const resetAllStores = () => {
  useActivationStore().reset();
  useAuthenticationStore().reset();
  useAuthorizationStore().reset();
  useBulkUploadStore().reset();
  useInvitationStore().reset();
  useInventoryStore().reset();
  useModeStore().reset();
  usePaymentProfileStore().reset();
  useUserStore().reset();
  usePurchaseRequestsStore().reset();
  useQRLabelsStore().reset();
  useSalesAgreementStore().reset();
  useTeamStore().reset();
  useNotificationStore().reset();
  useArtistStore().reset();
};
